<template>
  <div id="contenedor-contrato-eliminar-frente">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Frente </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar este frente? </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarFrente"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar">
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixContratoFrentes from './mixContratoFrentes';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'ContratoEliminarFrente',
  mixins: [mixContratoFrentes],
  components: {
    CustomButton,
  },
  props: {
    contratoFrente: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss">

</style>
